import type { AdvisorProductType } from './types';
import { advisorProductTypes } from './types';

export type AdvisorPlannerSearch = {
  country?: string;
  region?: string[];
  // CMS sticky-bar active chapter — the one id that filters the catalogue.
  // Absent with a non-empty `region` list = country-wide browse.
  active?: string;
  mood?: string[];
  type?: AdvisorProductType;
  page?: number;
  // Portal Mini Planner: which saved request this URL is editing.
  request?: string;
};

const isProductType = (value: unknown): value is AdvisorProductType =>
  typeof value === 'string' &&
  (advisorProductTypes as readonly string[]).includes(value);

const parseStringList = (value: unknown): string[] | undefined => {
  const raw = Array.isArray(value)
    ? value
    : typeof value === 'string' && value
      ? [value]
      : [];
  const items = [
    ...new Set(
      raw.filter(
        (entry): entry is string =>
          typeof entry === 'string' && entry.length > 0
      )
    ),
  ];
  return items.length > 0 ? items : undefined;
};

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const validateAdvisorPlannerSearch = (
  input: Record<string, unknown>
): AdvisorPlannerSearch => {
  const search: AdvisorPlannerSearch = {};
  if (typeof input.country === 'string' && input.country) {
    search.country = input.country;
  }
  const region = parseStringList(input.region);
  if (region) search.region = region;
  if (typeof input.active === 'string' && input.active) {
    search.active = input.active;
  }
  const mood = parseStringList(input.mood) ?? parseStringList(input.theme);
  if (mood) search.mood = mood;
  if (isProductType(input.type)) search.type = input.type;
  const page =
    typeof input.page === 'number'
      ? input.page
      : typeof input.page === 'string'
        ? Number(input.page)
        : Number.NaN;
  if (Number.isInteger(page) && page > 1) search.page = page;
  if (typeof input.request === 'string' && UUID_RE.test(input.request)) {
    search.request = input.request;
  }
  return search;
};
